module.exports = __webpack_public_path__ + "static/media/classic-snacks.4330b927.jpg";